import {
  FAULT_SERVICE_ASSURANCE_Url,
  ORDER_STATUS_Url,
  NEW_REQUEST_STATUS_Url,
} from "../const/URL";
import { IBillComplaintDetails } from "../interfaces/billComplaintDetails";
import { IServiceFaultListItem } from "../interfaces/fault";
import { IFaultDetails } from "../interfaces/faultDetails";
import { IFaultProgress } from "../interfaces/FaultProgress";
import { IOrderResult } from "../interfaces/orderDetails";
import { IServiceDetails } from "../interfaces/serviceDetails";
import hasRequestError from "../util/hasRequestError";
import axiosInstance from "./axiosInstance";
import { getCustomerReferenceNumber } from "./localStorage";

export const getFaultDetailsByRefNo = (obj: {
  faultReferenceNumber: string;
  customerReferenceNumber: string;
}) => {
  return axiosInstance
    .get(FAULT_SERVICE_ASSURANCE_Url + "/GetFaultDetails", { params: obj })
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.displayMessage);
      }
      return response.data.result as IFaultDetails;
    });
};

export const getFaultList = (
  serviceId: string
): Promise<IServiceFaultListItem[]> => {
  return axiosInstance
    .get(
      `${FAULT_SERVICE_ASSURANCE_Url}/GetServiceFaultList?serviceId=${serviceId}&customerReferenceNumber=${getCustomerReferenceNumber()}`
    )
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(res.data.displayMessage);
      }

      return res.data.result as IServiceFaultListItem[];
    });
};

export const getFaultProgressByRefNo = (obj: {
  faultReferenceNumber: string;
  customerReferenceNumber: string;
}) => {
  return (
    axiosInstance
      // .get(
      //   `${FAULT_SERVICE_ASSURANCE_Url}/GetFaultProgress?faultReferenceNumber=${faultReferenceNumber}&customerReferenceNumber=${getCustomerReferenceNumber()}`
      // )
      .get(FAULT_SERVICE_ASSURANCE_Url + "/GetFaultProgress", { params: obj })
      .then((res) => {
        if (hasRequestError(res)) {
          throw new Error(res.data.displayMessage);
        }

        return res.data.result as IFaultProgress;
      })
  );
};

export const getBillComplaintDetailsByRefNo = (obj: {
  faultReferenceNumber: string;
  customerReferenceNumber: string;
}) => {
  return axiosInstance
    .get(FAULT_SERVICE_ASSURANCE_Url + "/GetBillComplaintDetails", {
      params: obj,
    })
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(res.data.displayMessage);
      }

      return res.data.result as IBillComplaintDetails;
    });
};

export const getOrderDetailsByRefNo = (obj: {
  orderNumber: string;
  customerReferenceNumber: string;
}) => {
  return axiosInstance
    .get(ORDER_STATUS_Url, {
      params: obj,
    })
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(res.data.displayMessage);
      }

      return res.data.result as IOrderResult;
    });
};

export const getNewServiceOrder = (faultReferenceNumber: string) => {
  return axiosInstance
    .post(`${NEW_REQUEST_STATUS_Url}/${faultReferenceNumber}`, {})
    .then((res) => {
      if (hasRequestError(res)) {
        throw new Error(res.data.displayMessage);
      }

      return res.data.dataBundle as IServiceDetails;
    });
};
